import { z } from "zod";
import { idString } from "./common.js";
/** KPI Table — any number of KPIs referenced by id (resolved by the mock). */
export const KpiTableParamsSchema = z
    .object({
    kpiIds: z.array(idString),
})
    .strict();
export const defaultKpiTableParams = { kpiIds: [] };
//# sourceMappingURL=kpiTable.js.map